var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['widget.productFinder'] = (function () {
    'use strict';

    const SELECTORS = {
        button: '.product-finder-controls button[data-tag-id]',
        controlsWrapper: '.product-finder-controls-wrapper',
        controls: '.product-finder-controls',
        showAllText: '.show-all .text',
        refreshButton: '.product-finder-controls .btn-refresh',
        showAllButton: '.product-finder-controls-wrapper .show-all',
        noResults: '.no-results',
        card: '.product-card[data-tag-ids]',
        invisibleCard: '.product-card[data-tag-ids].d-none',
        visibleCard: '.product-card[data-tag-ids]:not(.d-none)'
    };

    const CLASSES = {
        active: 'active',
        hidden: 'd-none',
        initialAnimation: 'animate__animated',
        preventRepeatAnimation: 'no-reanimate'
    };

    const initialize = (widget) => {
        const buttons = widget.querySelectorAll(SELECTORS.button);
        if (!buttons.length) return;
        const refreshButton = widget.querySelector(SELECTORS.refreshButton);
        const showAllButton = widget.querySelector(SELECTORS.showAllButton);
        const controlsWrapper = widget.querySelector(SELECTORS.controlsWrapper);

        buttons.forEach(button => {
            button.addEventListener('click', () => {
                toggleButton(button);
                applyFilters(widget);
            });
        });

        if (refreshButton) {
            refreshButton.addEventListener('click', () => {
                clearFilters(widget);
            });
        }

        if (showAllButton) {
            showAllButton.addEventListener('click', () => {
                toggleHeight(controlsWrapper);
            });
        }

        applyFilters(widget, true);
    };

    const toggleButton = (button) => {
        const isActive = button.classList.toggle(CLASSES.active);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    };

    const clearFilters = (widget) => {
        const buttons = widget.querySelectorAll(SELECTORS.button);

        buttons.forEach(button => {
            button.classList.remove(CLASSES.active);
            button.setAttribute('aria-pressed', 'false');
        });

        applyFilters(widget);
    };

    const toggleHeight = (controlsWrapper) => {
        const controls = controlsWrapper.querySelector(SELECTORS.controls);
        controls.classList.toggle('no-max');

        const btnTexts = controlsWrapper.querySelectorAll(SELECTORS.showAllText);
        btnTexts.forEach(text => {
            text.classList.toggle('d-none');
        });
    };

    const applyFilters = (widget, isInit = false) => {
        const activeIds = getActiveIds(widget);
        const cards = widget.querySelectorAll(SELECTORS.card);
        const noResults = widget.querySelector(SELECTORS.noResults);

        cards.forEach(card => {
            const cardTagIds = getCardTagIds(card);
            const shouldShow = !activeIds.length || activeIds.every(id => cardTagIds.includes(id));
            card.classList.toggle(CLASSES.hidden, !shouldShow);
            card.classList.remove('mod-1', 'mod-2');
            if (!isInit) {
                card.classList.remove(CLASSES.initialAnimation);
                card.classList.add(CLASSES.preventRepeatAnimation);
            }
        });

        toggleRefreshButton(widget, activeIds.length > 0);

        const invisibleCards = widget.querySelectorAll(SELECTORS.invisibleCard);
        if (cards.length == invisibleCards.length) {
            noResults.classList.remove(CLASSES.hidden);
        } else {
            noResults.classList.add(CLASSES.hidden);

            const visibleCards = widget.querySelectorAll(SELECTORS.visibleCard);
            const remainder = visibleCards.length % 3;

            if (remainder > 0) {
                const remainderClass = `mod-${remainder}`;
                const lastCards = [...visibleCards].slice(remainder * -1);

                lastCards.forEach(card => {
                    card.classList.add(remainderClass);
                });
            }
        }
    };

    const toggleRefreshButton = (widget, shouldShow) => {
        const refreshButton = widget.querySelector(SELECTORS.refreshButton);
        if (!refreshButton) return;

        refreshButton.classList.toggle(CLASSES.hidden, !shouldShow);
        refreshButton.setAttribute('aria-selected', shouldShow ? 'true' : 'false');
    };

    const getActiveIds = (widget) => {
        return Array.from(widget.querySelectorAll(`${SELECTORS.button}.${CLASSES.active}`))
            .map(button => button.dataset.tagId)
            .filter(Boolean);
    };

    const getCardTagIds = (card) => {
        return (card.dataset.tagIds || '')
            .split(/\s+/)
            .filter(Boolean);
    };

    return {
        initialize
    };

})();